import { render, staticRenderFns } from "./MenuFoodDialog.vue?vue&type=template&id=9b308934&scoped=true"
import script from "./MenuFoodDialog.vue?vue&type=script&lang=js"
export * from "./MenuFoodDialog.vue?vue&type=script&lang=js"
import style0 from "./MenuFoodDialog.vue?vue&type=style&index=0&id=9b308934&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b308934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b308934')) {
      api.createRecord('9b308934', component.options)
    } else {
      api.reload('9b308934', component.options)
    }
    module.hot.accept("./MenuFoodDialog.vue?vue&type=template&id=9b308934&scoped=true", function () {
      api.rerender('9b308934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/MenuFoodDialog.vue"
export default component.exports